document.addEventListener('DOMContentLoaded', function () {
  const swiperContainers = document.querySelectorAll('.swiper.mySwiper2');

  swiperContainers.forEach(swiperContainer => {
    const logos = document.querySelectorAll('.header__heading-logo');
    const headerIcons = document.querySelectorAll('.icon-hamburger');

    if (!logos.length || !headerIcons.length) return;

    const blockNumber = swiperContainer.dataset.blockNumber;
    const blockNumbers = blockNumber
      ? blockNumber.split(',').map(num => num.trim()).filter(num => num !== '')
      : [];

    if (blockNumbers.length === 0) return;

    // Assign slide indices for reference
    const allSlides = swiperContainer.querySelectorAll('.swiper-slide');
    allSlides.forEach((slide, index) => {
      slide.dataset.slideIndex = index.toString();
    });

    function checkActiveSlide(swiper) {
      if (!swiper) return;
      const slideIndex = swiper.realIndex?.toString() || '0';

      if (blockNumbers.includes(slideIndex)) {
        logos.forEach(logo => logo.classList.add('active'));
        headerIcons.forEach(icon => icon.classList.add('active'));
      } else {
        logos.forEach(logo => logo.classList.remove('active'));
        headerIcons.forEach(icon => icon.classList.remove('active'));
      }
    }

    function bindSwiper(swiper) {
      if (!swiper) return;
      checkActiveSlide(swiper);

      // Listen to all transitions (includes thumbs & direct navigation)
      swiper.on('slideChange transitionEnd', function () {
        checkActiveSlide(this);
      });
    }

    // Wait until swiper is initialized
    const initSwiper = () => {
      const swiper = swiperContainer.swiper;
      if (swiper) {
        bindSwiper(swiper);
        return true;
      }
      return false;
    };

    if (!initSwiper()) {
      const interval = setInterval(() => {
        if (initSwiper()) clearInterval(interval);
      }, 300);
    }
  });



  
});


